const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const SKIP = ["/admin", "/console"];

export const getVid = () => {
  try {
    let v = localStorage.getItem("app_vid");
    if (!v) {
      v = (window.crypto?.randomUUID?.() || `${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`).replace(/-/g, "");
      localStorage.setItem("app_vid", v);
    }
    return v;
  } catch {
    return "anon";
  }
};

export const track = (event, path, meta = {}) => {
  try {
    if (typeof window === "undefined" || navigator.webdriver) return;
    const p = path || window.location.pathname;
    if (SKIP.some((s) => p.startsWith(s))) return;
    const body = JSON.stringify({
      event, path: p,
      referrer: event === "pageview" ? document.referrer || "" : "",
      vid: getVid(), width: window.innerWidth, meta,
    });
    fetch(`${API}/track`, { method: "POST", headers: { "Content-Type": "application/json" }, body, keepalive: true, credentials: "omit" }).catch(() => {});
  } catch {
    /* fire-and-forget */
  }
};
